var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 30L12.877 29.2283C20.2516 22.7392 24 17.0732 24 12.0927C24 5.03951 18.5373 0 12 0C5.46274 0 0 5.03951 0 12.0927C0 17.0732 3.74841 22.7392 11.123 29.2283L12 30ZM11.9993 26.4284C5.7415 20.745 2.66602 15.929 2.66602 12.1007C2.66602 6.58728 6.88484 2.69531 11.9993 2.69531C17.1139 2.69531 21.3327 6.58728 21.3327 12.1007C21.3327 15.929 18.2572 20.745 11.9993 26.4284ZM11.9997 5.36133C15.6816 5.36133 18.6663 8.36915 18.6663 12.0795C18.6663 15.7898 15.6816 18.7976 11.9997 18.7976C8.31778 18.7976 5.33301 15.7898 5.33301 12.0795C5.33301 8.36915 8.31778 5.36133 11.9997 5.36133ZM7.99902 12.0875C7.99902 9.86133 9.78988 8.05664 11.999 8.05664C14.2082 8.05664 15.999 9.86133 15.999 12.0875C15.999 14.3137 14.2082 16.1184 11.999 16.1184C9.78988 16.1184 7.99902 14.3137 7.99902 12.0875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/icon-pin.e63f8096187371d05a82de0aa7084e8c.svg";
export { ForwardRef as ReactComponent };